import { createElement, lazy } from 'react';

import { RouteObject } from 'react-router-dom';

import { LegacyV2Redirect } from './LegacyV2Redirect';
import { Urls } from './Urls';

const MainV2Page = lazy(() =>
  import('@/pages/v2/main').then((module) => ({ default: module.MainV2Page })),
);
const SearchV2Page = lazy(() =>
  import('@/pages/v2/search').then((module) => ({
    default: module.SearchV2Page,
  })),
);
const ArchiveV2Page = lazy(() =>
  import('@/pages/v2/archive').then((module) => ({
    default: module.ArchiveV2Page,
  })),
);
const ArchiveV2EntryPage = lazy(() =>
  import('@/pages/v2/archive').then((module) => ({
    default: module.ArchiveV2EntryPage,
  })),
);
const DumpV2Page = lazy(() =>
  import('@/pages/v2/dump').then((module) => ({ default: module.DumpV2Page })),
);
const CartV2Page = lazy(() =>
  import('@/pages/v2/cart').then((module) => ({ default: module.CartV2Page })),
);
const MetadataSettingsPage = lazy(() =>
  import('@/pages/v2/settings').then((module) => ({
    default: module.MetadataSettingsPage,
  })),
);
const NotFoundV2Page = lazy(() =>
  import('@/pages/v2/notFound').then((module) => ({
    default: module.NotFoundV2Page,
  })),
);

// GenericLayoutV2 아래에서 렌더
export const pageRoute: RouteObject[] = [
  {
    path: Urls.main.path,
    element: createElement(MainV2Page),
  },
  {
    path: Urls.search.path,
    element: createElement(SearchV2Page),
  },
  {
    // 폴더 미지정 진입 — 첫 top 폴더로 리다이렉트 (헤더 내비 진입점)
    path: Urls.archive.build(),
    element: createElement(ArchiveV2EntryPage),
  },
  {
    path: Urls.archive.path,
    element: createElement(ArchiveV2Page),
  },
  {
    path: Urls.dump.path,
    element: createElement(DumpV2Page),
  },
  {
    path: Urls.cart.path,
    element: createElement(CartV2Page),
  },
  {
    // 메타데이터 설정(ADMIN · METADATA_MANAGER · METADATA_EDITOR) — 노출은 헤더,
    // 화면 접근은 Section(useMetadataPermission), 차단은 서버 검증(규칙 #5)
    path: Urls.settingsMetadata.path,
    element: createElement(MetadataSettingsPage),
  },
  {
    // 기존 /v2/* 주소 — 접두사를 뗀 주소로 리다이렉트
    path: '/v2/*',
    element: createElement(LegacyV2Redirect),
  },
  {
    // 없는 주소 — 헤더 안에서 404 안내, 홈은 / (COM-21)
    path: '*',
    element: createElement(NotFoundV2Page),
  },
];
